import React from 'react';
import './AlertBanner.css';
import { THRESHOLDS, computeCurrentStatus } from '../utils/timelineConfig';

// One vocabulary across the page: DANGER / CAUTION / NORMAL, same as the chart
function AlertBanner({ indices }) {
  const { raceIndex, slowdownIndex, status, confidence } = indices;
  const level = computeCurrentStatus(raceIndex).status.toUpperCase();

  const levelClass = { DANGER: 'alert-danger', CAUTION: 'alert-warning', NORMAL: 'alert-safe' }[level];

  const getAlertMessage = () => {
    if (status === 'RACE_DOMINANT') {
      return raceIndex >= THRESHOLDS.DANGER
        ? `Race scenario dominant: the Race Index is above the ${THRESHOLDS.DANGER} danger line.`
        : 'Race scenario dominant: accelerators outweigh the brakes.';
    }
    if (status === 'BALANCED') {
      return 'Contested: accelerators and brakes are roughly balanced.';
    }
    return 'Slowdown dominant: governance and cooperation are holding the pace back.';
  };

  return (
    <div className={`alert-banner ${levelClass}`} role="status">
      <div className="alert-level">{level}</div>
      <div className="alert-message">{getAlertMessage()}</div>
      <dl className="alert-metrics">
        <div><dt>Race</dt><dd className="text-red">{raceIndex.toFixed(2)}</dd></div>
        <div><dt>Slowdown</dt><dd className="text-green">{slowdownIndex.toFixed(2)}</dd></div>
        <div><dt>Confidence</dt><dd>{Math.round(confidence * 100)}%</dd></div>
      </dl>
    </div>
  );
}

export default AlertBanner;
